export default __webpack_public_path__ + "static/media/abstract.9a594d99.svg";